export const LLM_URL =
  "https://sportsbox-server-pipeline-249376958558.us-central1.run.app/v1/llm";
